export const parseLocaledString = (localed: string) => {
  return +localed?.replace(/\s/g, '').replace(/,/g, '.')
}
